<template>
  <div class="img-wrapper">
    <div class="preload" v-if="!loaded">
      <div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <picture class="afb-image">
      <source
        v-if="imageUrl.sizes['2048x2048']"
        :srcset="`${imageUrl.sizes['2048x2048']}`"
        media="(min-width:  1441px)"
      />
      <source
        v-if="imageUrl.sizes['1536x1536']"
        :srcset="`${imageUrl.sizes['1536x1536']}`"
        media="(max-width: 1440px)"
      />
      <source
        v-if="imageUrl.sizes.medium_large"
        :srcset="`${imageUrl.sizes.medium_large}`"
        media="(max-width: 769px)"
      />
      <img
        :ref="`pic${_uid}`"
        :alt="imageUrl.alt"
        data-sizes="auto"
        :src="imageUrl.sizes.thumbnail"
      />
    </picture>
  </div>
</template>
<script>
export default {
  name: "AFBImage",
  props: {
    imageUrl: {
      type: [Object, Boolean],
      default: () => {},
    },
  },
  data() {
    return {
      loaded: false,
    };
  },
  async mounted() {
    const self = this;
    const picEl = this.$refs[`pic${this._uid}`];
    // use this to let know parent component when data is loaded
    picEl.onload = () => {
      self.loaded = true;
      self.$emit("onLoadEvent", true);
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/_colors";
img {
  object-fit: cover;
  width: 100%;
}
.img-wrapper {
  position: relative;
  height: 100%;
}
.preload {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  div {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 2em;
  }

  span {
    width: 0.3em;
    height: 1em;
    background-color: $orange;
  }

  span:nth-of-type(1) {
    animation: grow 1s -0.45s ease-in-out infinite;
  }

  span:nth-of-type(2) {
    animation: grow 1s -0.3s ease-in-out infinite;
  }

  span:nth-of-type(3) {
    animation: grow 1s -0.15s ease-in-out infinite;
  }

  span:nth-of-type(4) {
    animation: grow 1s ease-in-out infinite;
  }
}
@keyframes grow {
  0%,
  100% {
    transform: scaleY(1);
  }

  50% {
    transform: scaleY(2);
  }
}
</style>
